export default "__VITE_ASSET__561443be__"